import moment from 'moment-timezone';
import { tracking, _t } from '@bark/bark-core';

export default function () {
	const { Handlebars } = window;
	/**
	 * This is a javascript function which causes the modal to be shown on the user's screen
	 */
	const showModal = async (booking) => {
		await window.SellerApp.launchModule(
			'booking-cancellation',
			'__rctBookingCancellation',
			{
				trackingsArgs: booking,
				sellerProfileId: booking.seller_profile_id,
			},
		);
	};

	/**
	 * Binds click handlers to the submit and close buttons.
	 * Handling functions are sold separately
	 */
	const bindClickHandlers = () => {
		$(`#main-project-container`).on('click', '.js-booking-cancel', function (e) {
			e.preventDefault();
			const $self = $(this);
			const bookingId = $self.data('booking-id');
			const buyerId = $self.data('buyer-id');
			const projectId = $self.data('project-id');
			const sellerProfileId = $self.data('seller-profile-id');
			const startAt = $self.data('start-at');
			const endAt = $self.data('end-at');
			const date = $self.data('date');
			showModal({
				booking_id: bookingId,
				buyer_id: buyerId,
				project_id: projectId,
				seller_profile_id: sellerProfileId,
				date_of_booking: date,
				time_of_booking: `${startAt} - ${endAt}`,
			});
		});
	};
	const isEnabled = () => $('#show-booking-cancellation-cta')?.val() == '1';

	return {
		renderCancelBooking,
		isEnabled,
		showModal,
		bindClickHandlers,
	};
}

export const renderCancelBooking = (projectId, buyerId) => {
	console.log('rendering...');
	const cancelBookingContainer = $('#marketplace-cancel-booking-container');
	const cancelBookingTemplate = Handlebars.compile(
		document.getElementById('cancel-booking-template').innerHTML,
	);
	cancelBookingContainer.addClass('d-none');

	getSellerBooking(projectId, buyerId, ({ data, meta }) => {
		if (!data.length) {
			return;
		}
		data.sort((a, b) => b.id - a.id);

		const bookingsFound = data?.filter((booking) => {
			return booking?.attributes?.buyer_id == buyerId;
		});
		if (!bookingsFound.length) {
			return;
		} 
		const booking = {
			id: bookingsFound[0]?.attributes?.id,
			timezone: bookingsFound[0]?.attributes?.timezone,
			startAt: moment
				.tz(
					bookingsFound[0]?.attributes?.start_at,
					bookingsFound[0]?.attributes?.timezone,
				)
				?.format('h:mma'),
			endAt: moment
				.tz(bookingsFound[0]?.attributes?.end_at, bookingsFound[0]?.attributes?.timezone)
				?.format('h:mma'),
			date: moment
				.tz(
					bookingsFound[0]?.attributes?.start_at,
					bookingsFound[0]?.attributes?.timezone,
				)
				.format('dddd Do MMMM YYYY'),
			cancelled: bookingsFound[0]?.attributes?.deleted_at
				? moment
						.tz(
							bookingsFound[0]?.attributes?.deleted_at,
							bookingsFound[0]?.attributes?.timezone,
						)
						.format('dddd Do MMMM YYYY')
				: null,
			isCancelled: !!bookingsFound[0]?.attributes?.deleted_at,
			isPast: moment()
				.tz(bookingsFound[0]?.attributes?.timezone)
				.isAfter(
					moment.tz(
						bookingsFound[0]?.attributes?.end_at,
						bookingsFound[0]?.attributes?.timezone,
					),
				),
			projectId: bookingsFound[0]?.attributes?.project_id,
			sellerProfileId: bookingsFound[0]?.attributes?.seller_profile_id,
			buyerId: bookingsFound[0]?.attributes?.buyer_id,
			buyer_name: $('.buyer_name:first')?.text(),
		};
		cancelBookingContainer.html(cancelBookingTemplate(booking)).removeClass('d-none');
	});
};

export function getSellerBooking(projectId, buyerId, postAction = () => {}) {
	const bookingContainer = $('#marketplace-cancel-booking-container');
	Bark.api(
		`${window.Bark.ENV.api_hostname}/bookings/seller/${window?.Bark?.seller?.id}/bookings?project_id=${projectId}&include_deleted=true`.replace(
			/(-[0-9]+)-api.d.bark.com\//,
			'-1-api.d.bark.com/',
		),
		{},
		postAction,
		(error) => {
			console.log('failed', error);
		},
		'GET',
	);
}

export function exposeSellerFunctionsToWindow() {
	window.SellerFunctions = {};
	window.SellerFunctions.renderCancelBooking = renderCancelBooking;
}
